import { BellRing } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { ContactDialog } from "@/components/prospect/ContactDialog";
import { errText, frDateTime } from "@/components/prospect/common";

export function RemindersTab() {
  const [scope, setScope] = useState("today");
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => api.get("/prospect/reminders", { params: { scope } }).then(({ data }) => setRows(data)).catch((e) => toast.error(errText(e))), [scope]);
  useEffect(() => { load(); }, [load]);
  const onSaved = (id, p) => setRows((rs) => rs.map((r) => (r.id === id ? { ...r, ...p } : r)));
  if (!rows) return <p className="pl-muted">Chargement…</p>;
  const late = (r) => new Date(r.remind_at) < new Date();
  return (
    <div data-testid="reminders-tab">
      <div className="ps-legend">
        <button type="button" className={`ps-pill${scope === "today" ? " on" : ""}`} onClick={() => setScope("today")} data-testid="reminders-today">Aujourd'hui et en retard</button>
        <button type="button" className={`ps-pill${scope === "all" ? " on" : ""}`} onClick={() => setScope("all")} data-testid="reminders-all">Tous les rappels</button>
      </div>
      {!rows.length && <p className="pl-muted" data-testid="reminders-empty"><BellRing size={14} /> Aucun rappel prévu. Posez la couleur jaune sur un contact et choisissez une date de rappel.</p>}
      {rows.length > 0 && (
        <table className="ps-table ps-lines" data-testid="reminders-table">
          <thead><tr><th>Rappel</th><th>Contact</th><th>Téléphone</th><th>Fichier</th><th>Commentaire</th></tr></thead>
          <tbody>{rows.map((r, i) => (
            <tr key={r.id} style={{ background: r.color === "jaune" ? "#fef9c3" : "#fff" }} data-testid={`reminder-${r.id}`}>
              <td className={late(r) ? "ps-late" : ""}>{frDateTime(r.remind_at)}</td>
              <td><button type="button" className="ps-open" onClick={() => setOpen(i)} data-testid={`reminder-open-${r.id}`}><strong>{r.name || "—"}</strong><small>{r.city}</small></button></td>
              <td>{r.phone}</td>
              <td>{r.file_name}</td>
              <td>{r.comment}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
      {open !== null && <ContactDialog rows={rows} index={open} pos={open + 1} total={rows.length} onIndex={(i) => i >= 0 && i < rows.length && setOpen(i)} onSaved={onSaved} onClose={() => { setOpen(null); load(); }} />}
    </div>
  );
}
